"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMessageTemplateSchema = exports.createMessageTemplateSchema = exports.messageTemplateShape = exports.templateChannelEnum = void 0;
const zod_1 = require("zod");
exports.templateChannelEnum = zod_1.z.enum(['EMAIL', 'SMS', 'WHATSAPP', 'PRINT']);
exports.messageTemplateShape = {
    code: zod_1.z
        .string()
        .min(1)
        .max(50)
        .regex(/^[A-Z][A-Z0-9_]*$/, 'Template code must be SCREAMING_SNAKE_CASE'),
    name: zod_1.z.string().min(1).max(150),
    channel: exports.templateChannelEnum,
    subject: zod_1.z.string().max(255).optional(),
    body: zod_1.z.string().min(1),
    variables: zod_1.z.array(zod_1.z.string()).default([]),
};
exports.createMessageTemplateSchema = zod_1.z.object(exports.messageTemplateShape).refine((value) => value.channel !== 'EMAIL' || Boolean(value.subject), { message: 'subject is required for EMAIL templates', path: ['subject'] });
exports.updateMessageTemplateSchema = zod_1.z.object({
    name: exports.messageTemplateShape.name.optional(),
    subject: exports.messageTemplateShape.subject,
    body: exports.messageTemplateShape.body.optional(),
    variables: exports.messageTemplateShape.variables.optional(),
});
//# sourceMappingURL=message-template.schema.js.map